import { useEffect, useLayoutEffect, useRef, useState } from 'react'

/** A little "?" that opens an explainer — tap-friendly (hover alone doesn't exist on phones). */
export function InfoTip({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false)
  const [shift, setShift] = useState(0)
  const ref = useRef<HTMLSpanElement>(null)
  const pop = useRef<HTMLSpanElement>(null)
  // keep the popover fully on-screen: measure after open and shift horizontally as needed
  useLayoutEffect(() => {
    if (!open || !pop.current) return
    const r = pop.current.getBoundingClientRect()
    let dx = 0
    if (r.left < 10) dx = 10 - r.left
    else if (r.right > innerWidth - 10) dx = innerWidth - 10 - r.right
    if (dx !== 0) setShift(dx)
  }, [open])
  useEffect(() => { if (!open) setShift(0) }, [open])
  useEffect(() => {
    if (!open) return
    const close = (e: PointerEvent) => { if (!ref.current?.contains(e.target as Node)) setOpen(false) }
    addEventListener('pointerdown', close)
    return () => removeEventListener('pointerdown', close)
  }, [open])
  return (
    <span className="infotip" ref={ref}>
      <button className="infotip-btn" aria-label="what does this mean?" aria-expanded={open} onClick={() => setOpen(!open)}>?</button>
      {open && <span className="infotip-pop" role="tooltip" ref={pop} style={{ transform: `translateX(calc(-60% + ${shift}px))` }}>{children}</span>}
    </span>
  )
}
